import React from 'react'

import PropTypes from 'prop-types'

function EmbedTrigger({ openModal, embed, logoPath = null, ctaText = null }) {
  return (
    <div className="embed-trigger" onClick={() => openModal(embed)}>
      {logoPath && <img src={logoPath} alt={`${embed.title} logo`} className="embed-trigger__logo" />}
      <div className="embed-trigger__cta">{ctaText || `+ Add ${embed.title} preview`}</div>
    </div>
  )
}

EmbedTrigger.propTypes = {
  openModal: PropTypes.func.isRequired,
  embed: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  logoPath: PropTypes.string,
  ctaText: PropTypes.string,
}

export default EmbedTrigger
